// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".addon-preview__background[data-v-3d5dd780] {\n  width: 100%;\n  height: 256px;\n  overflow: hidden;\n  background: #fff;\n}", ""]);
// Exports
module.exports = exports;
